import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import FormContainer from "./FormContainer";
import { useTranslation } from "react-i18next";
import TextFieldTheme from "../../../shared/general/TextFieldTheme";

const EmployeeType = (props) => {
  const { formik } = props;
  const { t, i18n } = useTranslation();

  return (
    <FormContainer title={`${t("EmployeeType")}`}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Typography>{t("PaymentType")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>

          <TextFieldTheme
            select
            name="idPaymentType"
            value={formik.values.idPaymentType}
            onChange={(event) => {
              formik.setFieldValue("idPaymentType", event.target.value, true);
            }}
            onBlur={formik.handleBlur}
            error={(formik.touched.idPaymentType && formik.errors.idPaymentType)? true: false}
            helperText={(formik.touched.idPaymentType && formik.errors.idPaymentType)? formik.errors.idPaymentType: false}
          >
            <MenuItem value="1">{t("Daily")}</MenuItem>
            <MenuItem value="2">{t("Monthly")}</MenuItem>
          </TextFieldTheme>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography>{t("PaymentRound")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            select
            name="roundPayment"
            value={formik.values.roundPayment}
            onChange={(event) => {
              formik.setFieldValue("roundPayment", event.target.value, true);
            }}
            onBlur={formik.handleBlur}
            error={(formik.touched.roundPayment && formik.errors.roundPayment)? true: false}
            helperText={(formik.touched.roundPayment && formik.errors.roundPayment)? formik.errors.roundPayment: false}
          >
            <MenuItem value="1">1</MenuItem>
            <MenuItem value="2">2</MenuItem>
            <MenuItem value="3">3</MenuItem>
            <MenuItem value="4">4</MenuItem>
          </TextFieldTheme>
        </Grid>
      </Grid>
    </FormContainer>
  );
};

export default EmployeeType;
